// Styles for AccountOverviewNotification go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

interface AccountOverviewNotificationStyleProps {
  iconTheme?: string;
  bannerBackground?: string;
  bannerBorder?: string;
}

export const StyledAccountOverviewNotification = styled.div<AccountOverviewNotificationStyleProps>`
  .card {
    width: 100%;
    border-radius: ${toRem(14)};
    background-color: ${baseVariables.color['base20']};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} ${baseVariables.shadows.boxShadowTile};
  }
  .outer {
    padding-top: ${toRem(4)};
    padding-bottom: ${toRem(4)};
    padding-left: ${toRem(4)};
    padding-right: ${toRem(4)};
    border-radius: ${toRem(50)};
    box-shadow: 0 ${toRem(8)} ${toRem(20)} ${baseVariables.shadows.boxShadowTile};
  }
  .icon {
    ${({ iconTheme, bannerBorder }) =>
      bannerBorder
        ? `background-color: ${bannerBorder};`
        : iconTheme
        ? `background-color: ${baseVariables.color[iconTheme]};`
        : `background-color: ${baseVariables.color['bvyBase30']};`}
    height: ${toRem(40)};
    width: ${toRem(40)};
    text-align: center;
    justify-content: center;
    border-radius: ${toRem(50)};
  }
  .icon-size {
    height: ${toRem(48)};
    width: ${toRem(48)};
  }
  .icon-alert {
    font-size: ${toRem(20)};
  }
  .navheader {
    justify-content: space-between;
    width: 100%;
    flex-direction: column;
    @media ${baseVariables.mediaQuery.lg} {
      flex-direction: row;
    }
  }

  .notification-banner {
    ${({ bannerBackground }) => (bannerBackground ? `background-color: ${bannerBackground};` : '')};
    ${({ bannerBorder }) => (bannerBorder ? `border-left: ${toRem(8)} solid ${bannerBorder};` : '')};
  }
`;

export const StyledAccountOverviewNotificationV2 = styled.div`
  &.mt-5 {
    margin-top: ${toRem(8)} !important;
    @media ${baseVariables.mediaQuery.tablet} {
      margin-top: ${toRem(32)} !important;
    }
  }
  .header_wrapper {
    width: 100%;
    gap: ${toRem(8)};
  }
  .video-icon{
    position: relative;
    top: ${toRem(2)};
  }
`;
